import { COMMODITY } from "./action";

const initialState = {
  commList: [],
  commCreated: {},
  selectedComm: {},
  commUpdated: {}
};

export default function commodityReducer(state = initialState, action) {
  switch (action.type) {
    case COMMODITY.getAllCommList.success:
      return {
        ...state,
        commList: action.data,
        commCreated: {},
        commUpdated: {}
      };
    case COMMODITY.create.success:
      return {
        ...state,
        commCreated: action.data
      };
    case COMMODITY.edit.success:
      return {
        ...state,
        selectedComm: action.data
      };
    case COMMODITY.update.success:
      return {
        ...state,
        commUpdated: action.data
      };
    case COMMODITY.delete.success:
      return {
        ...state,
        commList: state.commList.filter(comm => comm.id !== action.data.id)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/commodities/reducer.js